import { useState, useEffect } from 'react';

const DEFAULT_WHATSAPP = 'https://whatsapp.com/channel/0029VbCEuEA1NCrMAsPILy3J';
const DEFAULT_TELEGRAM = 'https://t.me/+RLed8IfVgMINDg0';

export default function Chaine() {
  const [whatsappLink, setWhatsappLink] = useState(DEFAULT_WHATSAPP);
  const [telegramLink, setTelegramLink] = useState(DEFAULT_TELEGRAM);

  useEffect(() => {
    const saved = localStorage.getItem('adminSocialLinks');
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed.whatsapp) setWhatsappLink(parsed.whatsapp);
      if (parsed.telegram) setTelegramLink(parsed.telegram);
    }
  }, []);

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-8 text-white shadow-lg">
        <h2 className="text-2xl font-bold mb-2">Chaîne de communication</h2>
        <p className="text-blue-100">Rejoignez notre communauté officielle</p>
      </div>

      <div className="bg-white rounded-xl p-8 shadow-lg">
        <p className="text-gray-700 mb-6">
          Restez connecté avec SUCCESSLINK AGENCY ! Rejoignez notre chaîne WhatsApp et notre groupe Telegram pour recevoir des notifications importantes, des conseils exclusifs et échanger avec la communauté.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center justify-center p-8 bg-gradient-to-br from-green-500 to-green-600 rounded-xl text-white hover:shadow-xl transition cursor-pointer"
          >
            <i className="ri-whatsapp-line text-6xl mb-4"></i>
            <h3 className="font-bold text-xl mb-2">Chaîne WhatsApp</h3>
            <p className="text-sm text-green-100 text-center mb-4">Recevez nos actualités et notifications</p>
            <div className="px-6 py-2 bg-white/20 rounded-full text-sm font-semibold whitespace-nowrap">
              Rejoindre maintenant
            </div>
          </a>

          <a
            href={telegramLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center justify-center p-8 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl text-white hover:shadow-xl transition cursor-pointer"
          >
            <i className="ri-telegram-line text-6xl mb-4"></i>
            <h3 className="font-bold text-xl mb-2">Groupe Telegram</h3>
            <p className="text-sm text-blue-100 text-center mb-4">Échangez avec la communauté</p>
            <div className="px-6 py-2 bg-white/20 rounded-full text-sm font-semibold whitespace-nowrap">
              Rejoindre maintenant
            </div>
          </a>
        </div>

        <div className="bg-blue-50 rounded-lg p-6">
          <h3 className="font-bold text-gray-800 mb-3 flex items-center">
            <i className="ri-information-line text-blue-600 mr-2"></i>
            Pourquoi rejoindre ?
          </h3>
          <ul className="space-y-2">
            <li className="flex items-start">
              <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
              <span className="text-gray-700">Recevez les dernières actualités en temps réel</span>
            </li>
            <li className="flex items-start">
              <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
              <span className="text-gray-700">Accédez à des conseils et astuces exclusifs</span>
            </li>
            <li className="flex items-start">
              <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
              <span className="text-gray-700">Échangez avec d'autres membres de la communauté</span>
            </li>
            <li className="flex items-start">
              <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
              <span className="text-gray-700">Soyez informé des nouvelles opportunités de gains</span>
            </li>
            <li className="flex items-start">
              <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
              <span className="text-gray-700">Obtenez un support rapide de notre équipe</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
